<template>
    <section>
        <div class="section5" style="width: 100vw; margin-bottom: 150px;">
            <div class="mobile_con_wrap" style="display: flex; flex-direction: column; padding-top: 115px">
                <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 73px">
                    <div style="width: 39px"></div>
                    <p data-aos="fade-up"
                        data-aos-delay="0"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out" style="font-size: 30px; font-weight: 700; color: white; text-align: center; color: #000000; line-height: 1">
                        보도자료
                    </p>
                    <p @click="goPath('/mobile/pages/news')" style="font-size: 14px; color: #C0C0C0; text-decoration: underline; cursor: pointer;">더보기</p>
                </div>
                <div class="postBox" data-aos="fade-up"
                        data-aos-delay="0"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out" v-for="(item, index) in postList" :key="index" :style="{borderBottom: index != (postList.length - 1) ? '1px solid #E7E7E7' : 0}" style="padding: 20px 0">
                    <div style="display: flex">
                        <p style="font-size: 15px; color: #B7B7B7; font-weight: 700; margin-bottom: 10px; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 1; overflow: hidden;">{{item.date}}</p>
                        <p></p>
                    </div>
                    <div style="display: flex">
                        <p style="font-size: 18px; color: black; font-weight: 700; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;">{{item.title}}</p>
                        <p></p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
export default {
    components: {
        ChevronDownIcon
    },
    data() {
        return {
        }
    },
    watch: {
    },
    computed: {
        postList() {
            return this.$store.state.postList
        }
    },
    methods: {
        goPath(val) {
            this.$router.push(val)
        }
    }
    
}
</script>
<style>
    .section5 {
        width: 100vw;
        background: white;
        object-fit: inherit;
    }
    @keyframes position {
        from {
            margin-top: 50px
        } to {
            margin-top: 0px
        }
    }
</style>